<div class="container-fluid people-profile" *ngIf="peopleProfileInfo != null && peopleProfileInfo.statusCode =='200'">
    <h2>People Profile</h2>
    <form>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="employeeId">Employee Id :</label>&nbsp;
                    <label>{{peopleProfileInfo.employeeId}}</label>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="email">Email :</label>&nbsp;
                    <label>{{peopleProfileInfo.email}}</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="designation">Designation :</label>&nbsp;
                    <label>{{peopleProfileInfo.designation}}</label>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="jobLevel">Job Title :</label>&nbsp;
                    <label>{{peopleProfileInfo.jobLevel}}</label>
                </div>
            </div>
        </div>
       
       
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label for="serviceLine">Service Line:</label>&nbsp;
                        <label>{{peopleProfileInfo.serviceLine}}</label>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label for="officelocation">Office Location :</label>&nbsp;
                        <label>{{peopleProfileInfo.city}}</label>
                    </div>
                </div>
            </div>
            
       
        <div class="form-group">
            <label>Last Cached Date Time :</label>&nbsp;
            <label>{{peopleProfileInfo.cachedDateTime ? (peopleProfileInfo.cachedDateTime | date:'medium') : 'Not Found' }}</label>
        </div>

       
    </form>
</div>
<div class="container user-profile" *ngIf="peopleProfileInfo == null">
    <div>No People Profile Information Found.</div>
</div>